import { Component, inject } from '@angular/core';
import { formatToLocalISOString } from '../../pda/pda.model';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { DisbursementService } from 'src/app/shared/service/disbursment/disbursement.component.service';
import { PortService } from 'src/app/shared/service/disbursment/port.service';

@Component({
  selector: 'app-disbursment-filter',
  templateUrl: './disbursment-filter.component.html',
  styleUrls: ['./disbursment-filter.component.scss']
})
export class DisbursmentFilterComponent {
portAgentList: PortAgentFilter[] = [];
  filteredPortAgentList: PortAgentFilter[] = [];
  countryList: CountryFilter[] = [];
  filteredCountryList: CountryFilter[] = [];
  picList: PICFilter[] = [];
  filteredPICList: PICFilter[] = [];
  statusList: StatusFilter[] = [];
  filteredStatusList: StatusFilter[] = [];
  portList: PortFilter[] = [];
  filteredPortList: PortFilter[] = [];
  vesselList: VesselFilter[] = [];
  filteredVesselList: VesselFilter[] = [];
  clientList: ClientFilter[] = [];
  filteredClientList: ClientFilter[] = [];
  voyageList: VoyageFilter[] = [];
  filteredVoyageList: VoyageFilter[] = [];
  voyageControl = new FormControl('');
  selectedVoyages: string[] = [];
  segmentList: SegmentFilter[] = []; // ADDED
  filteredSegmentList: SegmentFilter[] = []; // ADDED
  lossPreventionList: LossPreventionFilter[] = [
    { type: 'PDA Savings', enabled: false, min: null, max: null },
    { type: 'FDA Savings', enabled: false, min: null, max: null },
    { type: 'Total Savings', enabled: false, min: null, max: null },
    { type: 'Roe Loss', enabled: false, min: null, max: null },

  ];
  overDueList: OverDueFilter[] = [
    { type: 'PDA Over Due', min: null, max: null },
    { type: 'FDA Over Due', min: null, max: null }
  ];
  searchText: string = '';
  countrySearchText: string = '';
  picSearchText: string = '';
  statusSearchText: string = '';
  portSearchText: string = '';
  vesselSearchText: string = '';
  clientSearchText: string = '';
  voyageSearchText: string = '';
  lossPreventionSearchText: string = '';
  overDueSearchText: string = '';
segmentSearchText: string = '';
  // ETA-ETD date selection
  etaDate: Date | null = null;
  etdDate: Date | null = null;



  // PDA date selection
  pdaStartDate: Date | null = null;
  pdaEndDate: Date | null = null;

  // FDA date selection
  fdaStartDate: Date | null = null;
  fdaEndDate: Date | null = null;

  selectedFilters = {
    page_size: 25,
    page: 1,
    query: "",
    filter: {
      eta_etd: { from_date: null as string | null, to_date: null as string | null },
      pda_processing_date: { from_date: null as string | null, to_date: null as string | null },
      fda_processing_date: { from_date: null as string | null, to_date: null as string | null },
      port_agent: [] as string[],
      country: [] as string[],
      vessel: [] as string[],
      segment: [] as string[],
      port: [] as string[],
      pic: [] as number[],
      status: [] as string[],
      client: [] as string[],
      voyage: [] as string[],
      roe_loss: { min_value: null as number | null, max_value: null as number | null, has_data: 'N' as 'Y' | 'N' },
      loss_prevention_pda: { min_value: null as number | null, max_value: null as number | null, has_data: 'N' as 'Y' | 'N' },
      loss_prevention_fda: { min_value: null as number | null, max_value: null as number | null, has_data: 'N' as 'Y' | 'N' },
      total_loss_prevention: { min_value: null as number | null, max_value: null as number | null, has_data: 'N' as 'Y' | 'N' },
      pda_over_due: { min_value: null as number | null, max_value: null as number | null },
      fda_over_due: { min_value: null as number | null, max_value: null as number | null },
    }
  };

  constructor(private portService: PortService, private disbursementService: DisbursementService) { }

  private dialogRef = inject(MatDialogRef<DisbursmentFilterComponent>);

  activeTabIndex = 0;

  tabs = [
    { label: 'Date' },
    { label: 'Status' },
    { label: 'PIC' },
    { label: 'Vessel' },
    { label: 'Segment' },
    { label: 'Port' },
    { label: 'Country' },
    { label: 'Port Agent' },
    { label: 'Client' },
    { label: 'Voyage' },
    { label: 'Savings' },
    { label: 'Over Due' },
  ];

  ngOnInit(): void {
    this.selectTab(0);
    this.fetchMasterData();
    this.loadFiltersFromSession();

    this.voyageControl.valueChanges.subscribe(value => {
      this.filterVoyages();
    });
  }

  fetchMasterData() {
    const params = {
      fields: ['all']
    };

    this.portService.getFilterMasterData(params).subscribe({
      next: (response: any) => {

        const status = response.status || [];
        this.statusList = status.map((status: any) => ({
          status: status.status,
          selected: false,
          pda: false,
          fda: false
        }));
        this.statusList.push({
          status: 'Final Status',
          selected: false,
          pda: false,
          fda: false
        });
        this.statusList.push({
          status: 'Inactive',
          selected: false,
          pda: false,
          fda: false
        });
        this.filteredStatusList = [...this.statusList];

        const portAgents = response.port_agent || [];
        this.portAgentList = portAgents.map((agent: any) => ({
          company_name: agent.company_name,
          selected: false
        }));
        this.filteredPortAgentList = [...this.portAgentList];

        const countries = response.country || [];
        this.countryList = countries.map((country: any) => ({
          country_id: country.country_id,
          country_name: country.name,
          selected: false
        }));
        this.filteredCountryList = [...this.countryList];

        const pic = response.pic || []
        this.picList = pic.map((pic: any) => ({
          user_id: pic.user,
          user_name: pic.names,
          selected: false
        }));
        this.filteredPICList = [...this.picList];

        const ports = response.port || [];
        this.portList = ports.map((port: any) => ({
          name: port.name,
          country_id: port.country_id,
          selected: false
        }));
        this.filteredPortList = [...this.portList];

        const vessels = response.vessels || [];
        this.vesselList = vessels.map((vessel: any) => ({
          company_id: vessel.company_id,
          name: vessel.name,
          selected: false
        }));
        this.filteredVesselList = [...this.vesselList];
        const segments = response.segments || response.segment || ['MR2', 'LR1', 'LR2', 'Suezmax', 'VLCC', 'Aframax', 'Handymax', 'Supramax', 'Capesize'];
        this.segmentList = segments.map((seg: any) => ({
          name: typeof seg === 'string' ? seg : seg.name || seg.segment_name,
          selected: false
        }));
        this.filteredSegmentList = [...this.segmentList];
        const clients = response.client || [];
        this.clientList = clients.map((client: any) => ({
          client_id: client.client_id,
          name: client.name,
          selected: false
        }));
        this.filteredClientList = [...this.clientList];

        const voyages = response.voyage || [];
        this.voyageList = voyages.map((voyage: any) => ({
          voyage_id: voyage.voyage_id,
          name: voyage.name,
          selected: false
        }));
        this.filteredVoyageList = [...this.voyageList];




      },
      error: (error: any) => {
        // Handle errors here
      }
    });
  }

  selectTab(index: number) {
    this.activeTabIndex = index;
  }
filterSegments() {
    const search = this.segmentSearchText.toLowerCase().trim();
    if (!search) {
      this.filteredSegmentList = [...this.segmentList];
    } else {
      this.filteredSegmentList = this.segmentList.filter(segment =>
        segment.name.toLowerCase().includes(search)
      );
    }
  }

  onSegmentChange(segment: SegmentFilter) {
    this.saveFiltersToSession();
  }
  clearSegmentFilter() {
    this.segmentList.forEach(segment => segment.selected = false);
    this.selectedFilters.filter.segment = [];
    this.segmentSearchText = '';
    this.filteredSegmentList = [...this.segmentList];
    this.saveFiltersToSession();
  }
  filterPortAgents() {
    const search = this.searchText.toLowerCase().trim();
    if (!search) {
      this.filteredPortAgentList = [...this.portAgentList];
    } else {
      this.filteredPortAgentList = this.portAgentList.filter(agent =>
        agent.company_name.toLowerCase().includes(search)
      );
    }
  }

  filterCountries() {
    const search = this.countrySearchText.toLowerCase().trim();
    if (!search) {
      this.filteredCountryList = [...this.countryList];
    } else {
      this.filteredCountryList = this.countryList.filter(country =>
        country.country_name.toLowerCase().includes(search)
      );
    }
  }

  filterPICs() {
    const search = this.picSearchText.toLowerCase().trim();
    if (!search) {
      this.filteredPICList = [...this.picList];
    } else {
      this.filteredPICList = this.picList.filter(pic =>
        pic.user_name.toLowerCase().includes(search)
      );
    }
  }

  filterStatuses() {
    const search = this.statusSearchText.toLowerCase().trim();
    if (!search) {
      this.filteredStatusList = [...this.statusList];
    } else if ('fda'.startsWith(search) || 'pda'.startsWith(search)) {
      this.filteredStatusList = [...this.statusList];
    } else {
      this.filteredStatusList = this.statusList.filter(status => {
        const statusLower = status.status.toLowerCase();

        if (search.startsWith('pda ')) {
          const searchTerm = search.substring(4);
          return statusLower.includes(searchTerm);
        } else if (search.startsWith('fda ')) {
          const searchTerm = search.substring(4);
          return statusLower.includes(searchTerm);
        } else {
          return statusLower.includes(search);
        }
      });
    }
  }

  filterPorts() {
    const search = this.portSearchText.toLowerCase().trim();
    if (!search) {
      this.filteredPortList = [...this.portList];
    } else {
      this.filteredPortList = this.portList.filter(port =>
        port.name.toLowerCase().includes(search)
      );
    }
  }

  filterVessels() {
    const search = this.vesselSearchText.toLowerCase().trim();
    if (!search) {
      this.filteredVesselList = [...this.vesselList];
    } else {
      this.filteredVesselList = this.vesselList.filter(vessel =>
        vessel.name.toLowerCase().includes(search)
      );
    }
  }

  filterClients() {
    const search = this.clientSearchText.toLowerCase().trim();
    if (!search) {
      this.filteredClientList = [...this.clientList];
    } else {
      this.filteredClientList = this.clientList.filter(client =>
        client.name.toLowerCase().includes(search)
      );
    }
  }

  filterVoyages() {
    const search = (this.voyageControl.value || '').toLowerCase().trim();
    if (!search) {
      this.filteredVoyageList = [...this.voyageList];
    } else {
      this.filteredVoyageList = this.voyageList.filter(voyage =>
        voyage.name.toLowerCase().includes(search) && !this.selectedVoyages.includes(voyage.name)
      );
    }
  }

  onVoyageSelected(event: any) {
    const voyageName = event.option.value;
    if (!this.selectedVoyages.includes(voyageName)) {
      this.selectedVoyages.push(voyageName);
      const voyage = this.voyageList.find(v => v.name === voyageName);
      if (voyage) voyage.selected = true;
    }
    this.voyageControl.setValue('');
    this.saveFiltersToSession();
  }

  addCustomVoyage() {
    const voyageName = this.voyageControl.value?.trim();
    if (voyageName && !this.selectedVoyages.includes(voyageName)) {
      this.selectedVoyages.push(voyageName);
    }
    this.voyageControl.setValue('');
    this.saveFiltersToSession();
  }

  removeVoyage(voyageName: string) {
    this.selectedVoyages = this.selectedVoyages.filter(v => v !== voyageName);
    const voyage = this.voyageList.find(v => v.name === voyageName);
    if (voyage) voyage.selected = false;
    this.saveFiltersToSession();
  }





  onPortAgentChange(agent: PortAgentFilter) {
    this.saveFiltersToSession();
  }

  onCountryChange(country: CountryFilter) {
    this.saveFiltersToSession();
  }

  onPICChange(pic: PICFilter) {
    this.saveFiltersToSession();
  }

  toggleStatus(status: StatusFilter, type: 'pda' | 'fda' | 'both') {
    if (type === 'pda') {
      status.pda = !status.pda;
    } else if (type === 'fda') {
      status.fda = !status.fda;
    } else if (type === 'both') {
      if (status.pda && status.fda) {
        status.pda = false;
        status.fda = false;
      } else {
        status.pda = true;
        status.fda = true;
      }
    }
    this.saveFiltersToSession();
  }

  getSelectedStatuses(): string[] {
    const selected: string[] = [];
    this.statusList.forEach(status => {
      if (status.status === 'Final Status' && (status.pda || status.fda)) {
        selected.push('Final Status');
      } else {
        if (status.pda) selected.push(`PDA ${status.status}`);
        if (status.fda) selected.push(`FDA ${status.status}`);
      }
    });
    return selected;
  }

  removeStatusChip(chip: string) {
    const isPDA = chip.startsWith('PDA');
    const isFDA = chip.startsWith('FDA');
    const statusName = chip.replace(/^(PDA|FDA) /, '');

    const status = this.statusList.find(s => s.status === statusName);
    if (status) {
      if (isPDA) status.pda = false;
      if (isFDA) status.fda = false;
      this.saveFiltersToSession();
    }
  }

  onPortChange(port: PortFilter) {
    this.saveFiltersToSession();
  }

  onVesselChange(vessel: VesselFilter) {
    this.saveFiltersToSession();
  }

  onClientChange(client: ClientFilter) {
    this.saveFiltersToSession();
  }

  onVoyageChange(voyage: VoyageFilter) {
    this.saveFiltersToSession();
  }

  onLossPreventionChange() {
    this.saveFiltersToSession();
  }

  onOverDueChange() {
    this.saveFiltersToSession();
  }

  clearDateFilter() {
    this.etaDate = null;
    this.etdDate = null;
    this.selectedFilters.filter.eta_etd = { from_date: null, to_date: null };
    this.saveFiltersToSession();
  }

  onEtaDateChange() {
    this.selectedFilters.filter.eta_etd.from_date = this.etaDate ? formatToLocalISOString(this.etaDate) : null;
    this.saveFiltersToSession();
  }

  onEtdDateChange() {
    this.selectedFilters.filter.eta_etd.to_date = this.etdDate ? formatToLocalISOString(this.etdDate) : null;
    this.saveFiltersToSession();
  }

  onPdaDateChange(event: { startDate: Date | null, endDate: Date | null }) {
    this.pdaStartDate = event.startDate;
    this.pdaEndDate = event.endDate;
    this.selectedFilters.filter.pda_processing_date = {
      from_date: event.startDate ? formatToLocalISOString(event.startDate) : null,
      to_date: event.endDate ? formatToLocalISOString(event.endDate) : null
    };
    this.saveFiltersToSession();
  }

  onFdaDateChange(event: { startDate: Date | null, endDate: Date | null }) {
    this.fdaStartDate = event.startDate;
    this.fdaEndDate = event.endDate;
    this.selectedFilters.filter.fda_processing_date = {
      from_date: event.startDate ? formatToLocalISOString(event.startDate) : null,
      to_date: event.endDate ? formatToLocalISOString(event.endDate) : null
    };
    this.saveFiltersToSession();
  }

  clearPdaFilter() {
    this.pdaStartDate = null;
    this.pdaEndDate = null;
    this.selectedFilters.filter.pda_processing_date = { from_date: null, to_date: null };
    this.saveFiltersToSession();
  }

  clearFdaFilter() {
    this.fdaStartDate = null;
    this.fdaEndDate = null;
    this.selectedFilters.filter.fda_processing_date = { from_date: null, to_date: null };
    this.saveFiltersToSession();
  }

  clearStatusFilter() {
    this.statusList.forEach(status => {
      status.selected = false;
      status.pda = false;
      status.fda = false;
    });
    this.selectedFilters.filter.status = [];
    this.statusSearchText = '';
    this.filteredStatusList = [...this.statusList];
    this.saveFiltersToSession();
  }

  clearPICFilter() {
    this.picList.forEach(pic => pic.selected = false);
    this.selectedFilters.filter.pic = [];
    this.picSearchText = '';
    this.filteredPICList = [...this.picList];
    this.saveFiltersToSession();
  }

  clearVesselFilter() {
    this.vesselList.forEach(vessel => vessel.selected = false);
    this.selectedFilters.filter.vessel = [];
    this.vesselSearchText = '';
    this.filteredVesselList = [...this.vesselList];
    this.saveFiltersToSession();
  }

  clearPortFilter() {
    this.portList.forEach(port => port.selected = false);
    this.selectedFilters.filter.port = [];
    this.portSearchText = '';
    this.filteredPortList = [...this.portList];
    this.saveFiltersToSession();
  }

  clearCountryFilter() {
    this.countryList.forEach(country => country.selected = false);
    this.selectedFilters.filter.country = [];
    this.countrySearchText = '';
    this.filteredCountryList = [...this.countryList];
    this.saveFiltersToSession();
  }

  clearPortAgentFilter() {
    this.portAgentList.forEach(agent => agent.selected = false);
    this.selectedFilters.filter.port_agent = [];
    this.searchText = '';
    this.filteredPortAgentList = [...this.portAgentList];
    this.saveFiltersToSession();
  }

  clearClientFilter() {
    this.clientList.forEach(client => client.selected = false);
    this.selectedFilters.filter.client = [];
    this.clientSearchText = '';
    this.filteredClientList = [...this.clientList];
    this.saveFiltersToSession();
  }

  clearVoyageFilter() {
    this.voyageList.forEach(voyage => voyage.selected = false);
    this.selectedFilters.filter.voyage = [];
    this.selectedVoyages = [];
    this.voyageControl.setValue('');
    this.voyageSearchText = '';
    this.filteredVoyageList = [...this.voyageList];
    this.saveFiltersToSession();
  }

  clearLossPreventionFilter() {
    this.lossPreventionList.forEach(lp => {
      lp.enabled = false;
      lp.min = null;
      lp.max = null;
    });
    this.selectedFilters.filter.roe_loss = { min_value: null, max_value: null, has_data: 'N' };
    this.selectedFilters.filter.loss_prevention_pda = { min_value: null, max_value: null, has_data: 'N' };
    this.selectedFilters.filter.loss_prevention_fda = { min_value: null, max_value: null, has_data: 'N' };
    this.selectedFilters.filter.total_loss_prevention = { min_value: null, max_value: null, has_data: 'N' };
    this.lossPreventionSearchText = '';
    this.saveFiltersToSession();
  }

  clearOverDueFilter() {
    this.overDueList.forEach(od => {
      od.min = null;
      od.max = null;
    });
    this.selectedFilters.filter.pda_over_due = { min_value: null, max_value: null };
    this.selectedFilters.filter.fda_over_due = { min_value: null, max_value: null };
    this.overDueSearchText = '';
    this.saveFiltersToSession();
  }

  clearAllFilters() {
    this.clearDateFilter();
    this.clearPdaFilter();
    this.clearFdaFilter();
    this.clearStatusFilter();
    this.clearPICFilter();
    this.clearVesselFilter();
    this.clearPortFilter();
    this.clearCountryFilter();
    this.clearPortAgentFilter();
    this.clearClientFilter();
    this.clearVoyageFilter();
    this.clearLossPreventionFilter();
    this.clearOverDueFilter();
    this.clearSegmentFilter();
  }

  applyFilters() {
    this.selectedFilters.filter.port_agent = this.portAgentList
      .filter(agent => agent.selected)
      .map(agent => agent.company_name);

    this.selectedFilters.filter.country = this.countryList
      .filter(country => country.selected)
      .map(country => String(country.country_name));

    this.selectedFilters.filter.pic = this.picList
      .filter(pic => pic.selected)
      .map(pic => pic.user_id);

    const selectedStatuses: string[] = [];
    this.statusList.forEach(status => {
      if (status.status === 'Final Status' && (status.pda || status.fda)) {
        selectedStatuses.push('Final Status');
      } else {
        if (status.pda) selectedStatuses.push(`PDA ${status.status}`);
        if (status.fda) selectedStatuses.push(`FDA ${status.status}`);
      }
    });
    this.selectedFilters.filter.status = selectedStatuses;

    this.selectedFilters.filter.eta_etd = {
      from_date: this.etaDate ? formatToLocalISOString(this.etaDate) : null,
      to_date: this.etdDate ? formatToLocalISOString(this.etdDate) : null
    };

    this.selectedFilters.filter.pda_processing_date = {
      from_date: this.pdaStartDate ? formatToLocalISOString(this.pdaStartDate) : null,
      to_date: this.pdaEndDate ? formatToLocalISOString(this.pdaEndDate) : null
    };

    this.selectedFilters.filter.fda_processing_date = {
      from_date: this.fdaStartDate ? formatToLocalISOString(this.fdaStartDate) : null,
      to_date: this.fdaEndDate ? formatToLocalISOString(this.fdaEndDate) : null
    };

    this.selectedFilters.filter.vessel = this.vesselList
      .filter(vessel => vessel.selected)
      .map(vessel => String(vessel.name));
    this.selectedFilters.filter.segment = this.segmentList.filter(s => s.selected).map(s => String(s.name)); // ADDED
    this.selectedFilters.filter.port = this.portList
      .filter(port => port.selected)
      .map(port => String(port.name));

    this.selectedFilters.filter.client = this.clientList
      .filter(client => client.selected)
      .map(client => String(client.name));

    this.selectedFilters.filter.voyage = this.selectedVoyages;

    // Loss Prevention filters
    const roeLoss = this.lossPreventionList.find(lp => lp.type === 'Roe Loss');
    this.selectedFilters.filter.roe_loss = {
      min_value: roeLoss?.enabled ? roeLoss.min : null,
      max_value: roeLoss?.enabled ? roeLoss.max : null,
      has_data: roeLoss?.enabled ? 'Y' : 'N'
    };

    const pdaLoss = this.lossPreventionList.find(lp => lp.type === 'PDA Savings');
    this.selectedFilters.filter.loss_prevention_pda = {
      min_value: pdaLoss?.enabled ? pdaLoss.min : null,
      max_value: pdaLoss?.enabled ? pdaLoss.max : null,
      has_data: pdaLoss?.enabled ? 'Y' : 'N'
    };

    const fdaLoss = this.lossPreventionList.find(lp => lp.type === 'FDA Savings');
    this.selectedFilters.filter.loss_prevention_fda = {
      min_value: fdaLoss?.enabled ? fdaLoss.min : null,
      max_value: fdaLoss?.enabled ? fdaLoss.max : null,
      has_data: fdaLoss?.enabled ? 'Y' : 'N'
    };

    const totalLoss = this.lossPreventionList.find(lp => lp.type === 'Total Savings');
    this.selectedFilters.filter.total_loss_prevention = {
      min_value: totalLoss?.enabled ? totalLoss.min : null,
      max_value: totalLoss?.enabled ? totalLoss.max : null,
      has_data: totalLoss?.enabled ? 'Y' : 'N'
    };

    // Over Due filters
    const pdaOverDue = this.overDueList.find(od => od.type === 'PDA Over Due');
    this.selectedFilters.filter.pda_over_due = {
      min_value: pdaOverDue?.min ?? null,
      max_value: pdaOverDue?.max ?? null
    };

    const fdaOverDue = this.overDueList.find(od => od.type === 'FDA Over Due');
    this.selectedFilters.filter.fda_over_due = {
      min_value: fdaOverDue?.min ?? null,
      max_value: fdaOverDue?.max ?? null,
    };

    this.dialogRef.close(this.selectedFilters);
  }

  closeFilter() {
    this.saveFiltersToSession();
    this.dialogRef.close();
  }

  saveFiltersToSession() {
    const filterState = {
      portAgentList: this.portAgentList,
      countryList: this.countryList,
      picList: this.picList,
      statusList: this.statusList,
      portList: this.portList,
      vesselList: this.vesselList,
      segmentList: this.segmentList,
      clientList: this.clientList,
      voyageList: this.voyageList,
      selectedVoyages: this.selectedVoyages,
      lossPreventionList: this.lossPreventionList,
      overDueList: this.overDueList,
      rowLoss: this.selectedFilters.filter.roe_loss,
      pdaLossPrevention: this.selectedFilters.filter.loss_prevention_pda,
      fdaLossPrevention: this.selectedFilters.filter.loss_prevention_fda,
      totalLossPrevention: this.selectedFilters.filter.total_loss_prevention,
      pdaOverDue: this.selectedFilters.filter.pda_over_due,
      fdaOverDue: this.selectedFilters.filter.fda_over_due,
      etaDate: this.etaDate,
      etdDate: this.etdDate,
      pdaStartDate: this.pdaStartDate,
      pdaEndDate: this.pdaEndDate,
      fdaStartDate: this.fdaStartDate,
      fdaEndDate: this.fdaEndDate
    };
    sessionStorage.setItem('disbursementFilterState', JSON.stringify(filterState));
  }

  loadFiltersFromSession() {
    const savedState = sessionStorage.getItem('disbursementFilterState');
    if (savedState) {
      const filterState = JSON.parse(savedState);

      // Wait for master data to load first
      const checkDataInterval = setInterval(() => {
        if (this.portAgentList.length > 0 || this.countryList.length > 0) {
          clearInterval(checkDataInterval);

          // Restore port agents
          if (filterState.portAgentList) {
            filterState.portAgentList.forEach((savedAgent: PortAgentFilter) => {
              const agent = this.portAgentList.find(a => a.company_name === savedAgent.company_name);
              if (agent) agent.selected = savedAgent.selected;
            });
            this.filteredPortAgentList = [...this.portAgentList];
          }

          // Restore countries
          if (filterState.countryList) {
            filterState.countryList.forEach((savedCountry: CountryFilter) => {
              const country = this.countryList.find(c => c.country_id === savedCountry.country_id);
              if (country) country.selected = savedCountry.selected;
            });
            this.filteredCountryList = [...this.countryList];
          }

          // Restore PICs
          if (filterState.picList) {
            filterState.picList.forEach((savedPIC: PICFilter) => {
              const pic = this.picList.find(p => p.user_id === savedPIC.user_id);
              if (pic) pic.selected = savedPIC.selected;
            });
            this.filteredPICList = [...this.picList];
          }

          // Restore statuses
          if (filterState.statusList) {
            filterState.statusList.forEach((savedStatus: StatusFilter) => {
              const status = this.statusList.find(s => s.status === savedStatus.status);
              if (status) {
                status.selected = savedStatus.selected;
                status.pda = savedStatus.pda;
                status.fda = savedStatus.fda;
              }
            });
            this.filteredStatusList = [...this.statusList];
          }

          // Restore ports
          if (filterState.portList) {
            filterState.portList.forEach((savedPort: PortFilter) => {
              const port = this.portList.find(p => p.name === savedPort.name);
              if (port) port.selected = savedPort.selected;
            });
            this.filteredPortList = [...this.portList];
          }

          // Restore vessels
          if (filterState.vesselList) {
            filterState.vesselList.forEach((savedVessel: VesselFilter) => {
              const vessel = this.vesselList.find(v => v.name === savedVessel.name);
              if (vessel) vessel.selected = savedVessel.selected;
            });
            this.filteredVesselList = [...this.vesselList];
          }

          if (filterState.segmentList) {
            filterState.segmentList.forEach((savedSeg: SegmentFilter) => {
              const seg = this.segmentList.find(s => s.name === savedSeg.name);
              if (seg) seg.selected = savedSeg.selected;
            });
            this.filteredSegmentList = [...this.segmentList];
          }

          // Restore clients
          if (filterState.clientList) {
            filterState.clientList.forEach((savedClient: ClientFilter) => {
              const client = this.clientList.find(c => c.client_id === savedClient.client_id);
              if (client) client.selected = savedClient.selected;
            });
            this.filteredClientList = [...this.clientList];
          }

          // Restore voyages
          if (filterState.voyageList) {
            filterState.voyageList.forEach((savedVoyage: VoyageFilter) => {
              const voyage = this.voyageList.find(v => v.voyage_id === savedVoyage.voyage_id);
              if (voyage) voyage.selected = savedVoyage.selected;
            });
            this.filteredVoyageList = [...this.voyageList];
          }

          // Restore selected voyages
          if (filterState.selectedVoyages) {
            this.selectedVoyages = filterState.selectedVoyages;
          }

          // Restore loss prevention
          if (filterState.lossPreventionList) {
            filterState.lossPreventionList.forEach((savedLP: LossPreventionFilter) => {
              const lp = this.lossPreventionList.find(l => l.type === savedLP.type);
              if (lp) {
                lp.enabled = savedLP.enabled;
                lp.min = savedLP.min;
                lp.max = savedLP.max;
              }
            });
          }

          // Restore loss prevention filter values
          if (filterState.rowLoss) {
            this.selectedFilters.filter.roe_loss = filterState.rowLoss;
          }
          if (filterState.pdaLossPrevention) {
            this.selectedFilters.filter.loss_prevention_pda = filterState.pdaLossPrevention;
          }
          if (filterState.fdaLossPrevention) {
            this.selectedFilters.filter.loss_prevention_fda = filterState.fdaLossPrevention;
          }
          if (filterState.totalLossPrevention) {
            this.selectedFilters.filter.total_loss_prevention = filterState.totalLossPrevention;
          }

          // Restore over due
          if (filterState.overDueList) {
            filterState.overDueList.forEach((savedOD: OverDueFilter) => {
              const od = this.overDueList.find(o => o.type === savedOD.type);
              if (od) {
                od.min = savedOD.min;
                od.max = savedOD.max;
              }
            });
          }

          // Restore over due filter values
          if (filterState.pdaOverDue) {
            this.selectedFilters.filter.pda_over_due = filterState.pdaOverDue;
          }
          if (filterState.fdaOverDue) {
            this.selectedFilters.filter.fda_over_due = filterState.fdaOverDue;
          }

          // Restore dates
          if (filterState.etaDate) {
            this.etaDate = new Date(filterState.etaDate);
          }
          if (filterState.etdDate) {
            this.etdDate = new Date(filterState.etdDate);
          }
          if (filterState.pdaStartDate) {
            this.pdaStartDate = new Date(filterState.pdaStartDate);
          }
          if (filterState.pdaEndDate) {
            this.pdaEndDate = new Date(filterState.pdaEndDate);
          }
          if (filterState.fdaStartDate) {
            this.fdaStartDate = new Date(filterState.fdaStartDate);
          }
          if (filterState.fdaEndDate) {
            this.fdaEndDate = new Date(filterState.fdaEndDate);
          }
        }
      }, 100);

      // Clear interval after 5 seconds to prevent infinite loop
      setTimeout(() => clearInterval(checkDataInterval), 5000);
    }
  }


  // method filter the fda status
  shouldShowFdaStatus(status: StatusFilter): boolean {
    return status.status !== 'On-Hold' &&
      status.status !== 'Final Status' &&
      status.status !== 'Submitted' &&
      status.status !== 'Re-Submitted' &&
      status.status !== 'Requested' &&
      status.status !== 'Inactive' &&
      status.status !== 'Re-Requested';
  }

  // method to display the check icon if the data selected
  hasFilterApplied(index: number): boolean {
    switch (index) {
      case 0: return !!(this.etaDate || this.etdDate || this.pdaStartDate || this.fdaStartDate);
      case 1: return this.statusList.some(s => s.pda || s.fda);
      case 2: return this.picList.some(p => p.selected);
      case 3: return this.vesselList.some(v => v.selected);
      case 4: return this.segmentList.some(s => s.selected); // ADDED
      case 5: return this.portList.some(p => p.selected);
      case 6: return this.countryList.some(c => c.selected);
      case 7: return this.portAgentList.some(a => a.selected);
      case 8: return this.clientList.some(c => c.selected);
      case 9: return this.selectedVoyages.length > 0;
      case 10: return this.lossPreventionList.some(lp => lp.enabled);
      case 11: return this.overDueList.some(od => od.min !== null || od.max !== null);
      default: return false;
    }
  }
}


interface SegmentFilter {
  name: string;
  selected: boolean;
}

interface PortAgentFilter {
  company_name: string;
  selected: boolean;
}

interface CountryFilter {
  country_id: number;
  country_name: string;
  selected: boolean;
}

interface PICFilter {
  user_id: number;
  user_name: string;
  selected: boolean;
}

interface StatusFilter {
  status: string;
  selected: boolean;
  pda: boolean;
  fda: boolean;
}

interface PortFilter {
  name: string;
  country_id: number;
  selected: boolean;
}

interface VesselFilter {
  company_id: number;
  name: string;
  selected: boolean;
}

interface ClientFilter {
  client_id: number;
  name: string;
  selected: boolean;
}

interface VoyageFilter {
  voyage_id: number;
  name: string;
  selected: boolean;
}

interface LossPreventionFilter {
  type: string;
  enabled: boolean;
  min: number | null;
  max: number | null;
}

interface OverDueFilter {
  type: string;
  min: number | null;
  max: number | null;
}